import { ListItem } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { SiteRoles } from '../users/serverApi/types/ISiteRole';

export function getIntegrationSiteRoleItems(): ListItem[] {
  return [
    { content: <div>{Messages.siteRole_IntegrationAdmin()}</div>, testId: 'integration-site-role-admin', value: SiteRoles.SiteAdministratorCreator },
    { content: <div>{Messages.siteRole_IntegrationCreator()}</div>, testId: 'integration-site-role-creator', value: SiteRoles.Creator },
    { content: <div>{Messages.siteRole_IntegrationExplorer()}</div>, testId: 'integration-site-role-explorer', value: SiteRoles.Explorer },
    { content: <div>{Messages.siteRole_IntegrationViewer()}</div>, testId: 'integration-site-role-viewer', value: SiteRoles.Viewer },
  ];
}

export function getIntegrationSiteRoleItemsForUpdate(): ListItem[] {
  return [
    ...getIntegrationSiteRoleItems(),
    { separator: true },
    { content: <div>{Messages.siteRole_Unlicensed()}</div>, testId: 'integration-site-role-unlicensed', value: SiteRoles.Unlicensed },
  ];
}
